import * as React from 'react';

const SvgFormAdd = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", d: "M13 19v-6h6v-2h-6V5h-2v6H5v2h6v6h2Z" })
);

export { SvgFormAdd as default };
//# sourceMappingURL=FormAdd.es.js.map
